// Auto-generated from src/styles/export/breakpoint.scss
// Do not edit this file directly - edit the SCSS source instead

export const exports = {
  "xs": "0",
  "sm": "480px",
  "md": "768px",
  "lg": "992px",
  "xl": "1240px",
  "xxl": "1380px"
};

export default exports;
